import clsx from "clsx";

/**
 * Plain label-over-number, no icons (§3.2 / round-3 rule 5). The number is
 * colored only where the state itself has a color; pass `numberClassName`
 * for that. Clickable tiles (state filters) get a hover ring.
 */
export function KpiTile({
  label,
  value,
  hint,
  numberClassName = "text-content-primary",
  onClick,
  active = false,
}: {
  label: string;
  value: React.ReactNode;
  hint?: string | null;
  numberClassName?: string;
  onClick?: () => void;
  active?: boolean;
}) {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      onClick={onClick}
      className={clsx(
        "bg-white rounded-lg p-4 shadow-sm border text-left w-full",
        active ? "border-brand-primary" : "border-[#E9E9EB]",
        onClick && "hover:border-brand-primary-light transition-colors",
      )}
    >
      <p className="text-xs text-gray-500 mb-1">{label}</p>
      <p className={clsx("text-2xl font-semibold", numberClassName)}>{value}</p>
      {hint && <p className="text-[11px] text-gray-500 mt-1">{hint}</p>}
    </Tag>
  );
}
